import qs from 'qs'

const axios = require('axios')

// array in local storage for registered users
const users = JSON.parse(localStorage.getItem('users')) || []

export function configureFakeBackend() {
  const realFetch = window.fetch
  window.fetch = function (url, opts) {
    return new Promise((resolve, reject) => {
      if (url.endsWith('/auth/token/') && opts.method === 'POST') {
        const params = JSON.parse(opts.body)
        axios({
          method: 'post',
          url: process.env.VUE_APP_USER_AUTHDOMAIN,
          data: qs.stringify({
            client_id: params.client_id,
            client_secret: params.client_secret,
            grant_type: 'password',
            username: params.email,
            password: params.password,
            totpc: params.totpc,
          }),
          headers: {
            'content-type': 'application/x-www-form-urlencoded;charset=utf-8',
          },
        })
          .then((response) => {
            const responseJson = {
              token: response.data.access_token,
              refresh_token: response.data.refresh_token,
              expires_in: Date.now() + response.data.expires_in,
              member: response.data.member,
            }
            resolve({
              ok: true,
              text: () => Promise.resolve(JSON.stringify(responseJson)),
            })
          })
          .catch((error) => {
            console.log(error)
            reject('Oups... Tes identifiants sont invalides !')
          })
        return
      }
      if (url.endsWith('social/auth/convert-token/') && opts.method === 'POST') {
        const params = JSON.parse(opts.body)
        const { token } = params
        axios({
          method: 'post',
          url: `${process.env.VUE_APP_API}social/auth/convert-token/`,
          data: qs.stringify({
            client_id: params.client_id,
            client_secret: params.client_secret,
            grant_type: 'convert_token',
            backend: params.backend,
            token,
          }),
          headers: {
            'content-type': 'application/x-www-form-urlencoded;charset=utf-8',
          },
        })
          .then((response) => {
            const responseJson = {
              token: response.data.access_token,
              refresh_token: response.data.refresh_token,
              expires_in: Date.now() + response.data.expires_in,
              // member: response.data.member,
            }
            resolve({
              ok: true,
              text: () => Promise.resolve(JSON.stringify(responseJson)),
            })
          })
          .catch((error) => {
            console.log(error)
            reject('Oups... Tes identifiants sont invalides !')
          })
        return
      }
      // get users
      if (url.endsWith('/users/me') && opts.method === 'GET') {
        axios({
          method: 'get',
          url: `${process.env.VUE_APP_API}users/me/`,
          headers: {
            'content-type': 'application/json',
          },
        })
          .then((response) => {
            const responseJson = {
              uuid: response.data.uuid,
              first_name: response.data.first_name,
              last_name: response.data.last_name,
              company: response.data.company,
              email: response.data.email,
              profile_picture: response.data.profile_picture,
              job_position: response.data.job_position,
              permissions: response.data.permissions,
            }
            resolve({
              ok: true,
              text: () => Promise.resolve(JSON.stringify(responseJson)),
            })
          })
          .catch((error) => {
            console.log(error)
            reject('Oups... Tes identifiants sont invalides !')
          })
        return
      }

      // get user by id
      if (url.match(/\/users\/\d+$/) && opts.method === 'GET') {
        // check for fake auth token in header and return user if valid, this security is implemented server side in a real application
        if (opts.headers && opts.headers.Authorization === 'Bearer fake-jwt-token') {
          // find user by id in users array
          const urlParts = url.split('/')
          const id = parseInt(urlParts[urlParts.length - 1])
          const matchedUsers = users.filter((user) => {
            return user.id === id
          })
          const user = matchedUsers.length ? matchedUsers[0] : null

          // respond 200 OK with user
          resolve({ ok: true, text: () => JSON.stringify(user) })
        } else {
          // return 401 not authorised if token is null or invalid
          reject('Unauthorised')
        }

        return
      }

      // reset password
      if (url.endsWith('/auth/password_reset/') && opts.method === 'POST') {
        const params = JSON.parse(opts.body)
        axios({
          method: 'post',
          url: `${process.env.VUE_APP_API}auth/password_reset/`,
          data: params.email,
          headers: {
            'content-type': 'application/json',
          },
        })
          .then((response) => {
            resolve({
              ok: true,
              text: () => Promise.resolve(JSON.stringify(response)),
            })
          })
          .catch((error) => {
            console.log(error)
            reject("Oups... L'email n'est pas correct")
          })
        return
      }

      // get application from email
      if (url.endsWith('/get_applications/') && opts.method === 'GET') {
        const params = JSON.parse(opts.body)
        axios({
          method: 'post',
          url: process.env.VUE_APP_AUTHDOMAIN,
          data: qs.stringify({
            client_id: process.env.VUE_APP_CLIENT_ID,
            client_secret: process.env.VUE_APP_CLIENT_SECRET,
            grant_type: 'client_credentials',
          }),
          headers: {
            'content-type': 'application/x-www-form-urlencoded;charset=utf-8',
          },
        })
          .then((response) => {
            axios({
              method: 'get',
              url: `${process.env.VUE_APP_API_V2}get_applications?email=${encodeURIComponent(params.email.email)}`,
              headers: {
                'x-toast-off': true,
                'content-type': 'application/x-www-form-urlencoded;charset=utf-8',
                Authorization: `Bearer ${response.data.access_token}`,
              },
            })
              .then((response) => {
                resolve({
                  ok: true,
                  text: () => Promise.resolve(JSON.stringify(response.data)),
                })
              })
              .catch((error) => {
                console.log(error)
                if (error.response.status === 404) {
                  reject('Ton compte est introuvable')
                }
                reject(
                  "Oups.... Un problème est survenu ! Si le problème persiste, contacte-nous à l'adresse support@heedesk.io",
                )
              })
          })
          .catch((error) => {
            console.log(error)
            reject("Oups.... Ton compte n'est rattaché à aucune entreprise")
          })
      }

      // change password
      if (url.endsWith('/auth/password_reset/confirm/') && opts.method === 'POST') {
        const params = JSON.parse(opts.body)
        axios({
          method: 'post',
          url: `${process.env.VUE_APP_API}auth/password_reset/confirm/`,
          data: params,
          headers: {
            'content-type': 'application/json',
          },
        })
          .then((response) => {
            resolve({
              ok: true,
              text: () => Promise.resolve(JSON.stringify(response)),
            })
          })
          .catch((error) => {
            if (
              error.response.status == 400 &&
              error.response.data.password[0] === 'The password is too similar to the email address.'
            ) {
              reject('Votre mot de passe est trop similaire à votre email, choisissez-en un autre.')
            } else {
              reject('Oups... Une erreur est survenue')
            }
          })
        return
      }

      // register user
      if (url.endsWith('/users/') && opts.method === 'POST') {
        const params = JSON.parse(opts.body)
        // let encoded_token = btoa(process.env.VUE_APP_CLIENT_ID + ":" + process.env.VUE_APP_CLIENT_SECRET)
        axios({
          method: 'post',
          url: process.env.VUE_APP_AUTHDOMAIN,
          data: qs.stringify({
            client_id: process.env.VUE_APP_CLIENT_ID,
            client_secret: process.env.VUE_APP_CLIENT_SECRET,
            grant_type: 'client_credentials',
          }),
          headers: {
            'content-type': 'application/x-www-form-urlencoded;charset=utf-8',
          },
        })
          .then((response) => {
            axios({
              method: 'post',
              url: process.env.VUE_APP_REGISTERDOMAIN,
              data: {
                email: params.email,
                first_name: params.first_name,
                last_name: params.last_name,
                password: params.password,
              },
              headers: {
                'content-type': 'application/json',
                authorization: `Bearer ${response.data.access_token}`,
              },
            })
              .then((response) => {
                const responseJson = {
                  uuid: response.data.uuid,
                  first_name: response.data.first_name,
                  last_name: response.data.last_name,
                  email: response.data.email,
                }
                localStorage.setItem('user_object', JSON.stringify(responseJson))
                resolve({
                  ok: true,
                  text: () => Promise.resolve(JSON.stringify(responseJson)),
                })
              })
              .catch((response) => {
                reject('Oups... Tes identifiants sont invalides !')
              })
          })
          .catch((error) => {
            console.log(error)
            reject('Oups... Tes identifiants sont invalides !')
          })
      }

      // pass through any requests not handled above
      // realFetch(url, opts).then(response => resolve(response));
    })
  }
}
